import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import RedirectPage from './pages/RedirectPage';

const App = () => {
  return (
    <Router>
      <TokenProviderWrapper />
    </Router>
  );
};

const TokenProviderWrapper = () => {
  return (
        <Routes>
          {/* update paths before deploy - ask peter what it should be */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<RedirectPage />} />  
        </Routes>
  );
};

export default App;